import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import SendIcon from "@mui/icons-material/Send";
import {
  deletePost,
  resetPostDeleteState,
  setSelectPostToViewPrayers,
  likePost,
  setQuickMessageData,
  savePost,
  setViewWhoIsPrayingModal,
} from "../features/posts/postSlice";
import TimeAgo from "components/utils/LocalizedTimeAgo";
import { MdEmojiPeople } from "react-icons/md";
import "../css/components/postItem.css";
import { setViewSendQuickMessageModal } from "features/posts/postSlice";
import useToggleDropdown from "../hooks/useToggleDropdown";
import { FaPray } from "react-icons/fa";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import styled from "styled-components";
import PostItemImage from "./posts/PostItemImage";
import { addItemToPrayerWall } from "features/sidebar/sidebarSlice";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { DotEle, DotsWrap, DotsBtn } from "./dots/dots.styled";

import {
  PostTextWrap,
  PostSubText,
  SeeMoreBtn,
  SeeMore,
  pBtnSmall,
} from "./main.styled";
import { GoCommentDiscussion } from "react-icons/go";
import DestructiveConfirmModal from "components/modals/DestructiveConfirmModal";
import { toast } from "react-toastify";

import * as timeago from "timeago.js";
import es from "timeago.js/lib/lang/es";
import SpinnerSmall from "./SpinnerSmall";
import { useTranslation } from "react-i18next";
import { useAppLanguage } from "i18n/useAppLanguage";
timeago.register("es", es);

function PostItem({ index, post, postId, canViewWhoisPraying }) {
  const { t: translate } = useTranslation();
  const { currentLanguage } = useAppLanguage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ref1 = useRef(null);
  const [postText, setPostText] = useState(post.postText.text);
  const [isDropped, setIsDropped] = useToggleDropdown(ref1);
  const handleDropDown = () => {
    setIsDropped.toggle(ref1);
  };
  const [postLikes, setPostLikes] = useState();
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [color, setColor] = useState("gray");
  const { user, admin, moderator } = useSelector((state) => state.auth);
  const {
    likePostLoading,
    isPostLikeLoading,
    isPostDeletedLoading,
    isPostDeletedSuccess,
    isPostDeletedError,
    postDeleteMessage,
  } = useSelector((state) => state.posts);
  const [profileImage, setProfileImage] = useState("generic.png");
  const { profileChurch } = useSelector((state) => state.profileChurch);
  const [isUserInLikes, setIsUserInLikes] = useState(false);

  useEffect(() => {
    if (post.likes && post.likes.length > 0) {
      setPostLikes(post.likes.length);
    } else {
      setPostLikes(0);
    }
    if (post.creator?.profileImg && !post.isAnonymous) {
      setProfileImage(post.creator.profileImg.url);
    }
    if (post.likes?.find((ele) => ele.toString() === user._id)) {
      setIsUserInLikes(true);
      setColor("#00B4CC");
    }
  }, [user, navigate, post, profileChurch.moderators, profileChurch]);

  useEffect(() => {
    if (isUserInLikes) {
      setColor("#00B4CC");
    }
  }, [isUserInLikes]);

  useEffect(() => {
    if (post.postText.isLongText) {
      setPostText(post.postText.text.slice(0, 650));
    }
  }, []);

  useEffect(() => {
    if (isPostDeletedSuccess) setConfirmDeleteOpen(false);
  }, [isPostDeletedSuccess]);

  useEffect(() => {
    if (confirmDeleteOpen && isPostDeletedError && postDeleteMessage) {
      toast.error(postDeleteMessage);
    }
  }, [confirmDeleteOpen, isPostDeletedError, postDeleteMessage]);

  const handleLikePost = () => {
    if (user._id === post.creator?._id) {
      dispatch(
        setSelectPostToViewPrayers({
          id: post._id,
          usersPraying: post.likes,
        }),
      );

      //show modal with users who are praying
      dispatch(setViewWhoIsPrayingModal(true));
      return;
    } else if (isUserInLikes) {
      return;
    } else {
      dispatch(
        likePost({
          postId: post._id,
          index: index,
        }),
      );
    }
  };

  let newDate = new Date(post.createdAt);

  const handleGoToPost = () => {
    navigate(`/posts/${postId}`);
  };
  const handleSavePost = () => {
    dispatch(
      savePost({
        postId: post._id,
        index: index,
      }),
    );
  };
  const handleDelete = () => {
    dispatch(resetPostDeleteState());
    setIsDropped.off();
    setConfirmDeleteOpen(true);
  };

  const handleConfirmDelete = () =>
    dispatch(deletePost({ postId: post._id, index }));

  const handleSendQuickMessage = () => {
    dispatch(
      setQuickMessageData({
        userId: post.creator?._id,
        fullName: post.creator?.fullName,
        userType: post.userType,
        profileImage: post.creator?.profileImg?.url,
      }),
    );
    dispatch(setViewSendQuickMessageModal(true));
  };

  const handleAddToPrayerWall = () => {
    dispatch(
      addItemToPrayerWall({
        churchId: profileChurch._id,
        postData: {
          postDate: post.createdAt,
          userId: post.creator?._id,
          fullName: post.creator?.fullName,
          postText: post.postText.text,
          postTextCondensed: post.postText.postTextCondensed
            ? post.postText.postTextCondensed
            : post.postText.text,
          userImage: post.creator?.profileImg?.url,
        },
        postId: post._id,
      }),
    );
  };

  return (
    <div style={{ zIndex: `${Math.abs(99 - Number(index))}` }} className="post">
      <div className="postInfo">
        <div className="postItemDate">
          <TimeAgo datetime={newDate} locale={currentLanguage} />
        </div>
        <div className="postItemDots" ref={ref1}>
          <DotsBtn onClick={handleDropDown}>
            <MoreHorizIcon />
          </DotsBtn>
          {isDropped && (
            <DotsWrap right={"5px"}>
              <DotEle onClick={handleGoToPost}>
                <NewspaperIcon className="postItemDotsIcon" />
                {translate("web:general.viewPost")}
              </DotEle>

              {!post.isAnonymous && post.creator?._id !== user._id && (
                <DotEle onClick={handleSendQuickMessage}>
                  <SendIcon className="postItemDotsIcon" />
                  {translate("feed:directMessage")}
                </DotEle>
              )}
              <DotEle onClick={handleSavePost}>
                <SaveAltIcon className="postItemDotsIcon" />
                {translate("web:general.save")}
              </DotEle>
              {(post.creator?._id === user._id ||
                post.postedToId?.toString() === user._id ||
                admin[profileChurch._id] ||
                moderator[profileChurch._id]) && (
                <>
                  <DotEle onClick={handleAddToPrayerWall}>
                    <FormatListBulletedIcon className="postItemDotsIcon" />
                    {translate("web:general.addToPrayerWall")}
                  </DotEle>
                  <DotEle style={{ color: "red" }} onClick={handleDelete}>
                    {" "}
                    <DeleteOutlineIcon className="postItemDotsIcon" />
                    {translate("web:general.delete")}
                  </DotEle>
                </>
              )}
            </DotsWrap>
          )}
        </div>
      </div>
      <div className="postItemTop">
        <div className="postUser">
          <div className="postItemUserImg">
            {!post.isAnonymous ? (
              <img className="postImageImg" src={profileImage} alt="u" />
            ) : (
              <AccountCircleIcon
                style={{
                  color: "var(--lightThemeFontColor)",
                  width: "35px",
                  height: "35px",
                }}
              />
            )}
          </div>
          <div className="postItemName">
            {post.isAnonymous ? (
              <i>Anonymous</i>
            ) : (
              (post.creator?.fullName ?? "Unknown")
            )}
            <StyledMTA>
              {" "}
              <TimeAgo datetime={newDate} />{" "}
            </StyledMTA>
          </div>

          <PostItemType
            style={{
              backgroundColor:
                post.postType === "Prayer Request"
                  ? "#46801fac"
                  : post.postType === "Praise"
                    ? "#f5a623ac"
                    : "#4a90e2ac",
            }}
            visible={true}
          >
            {translate(`web:general.${post.postType}`) ?? post.postType}
          </PostItemType>
        </div>
      </div>

      {post.hasImage ? (
        <div className="postItemMiddle">
          <div className="postImageWrap" onClick={handleGoToPost}>
            <PostItemImage image={post.image} />
          </div>
          <PostTextWrap hasImage={true}>
            {postText.split("\n").map((subtext) => {
              return <PostSubText>{subtext}</PostSubText>;
            })}
            {post.postText.isLongText && (
              <SeeMore>
                <SeeMoreBtn onClick={handleGoToPost}>
                  {translate("common:showMore")}
                </SeeMoreBtn>
              </SeeMore>
            )}
          </PostTextWrap>
        </div>
      ) : (
        <div className="postItemMiddle">
          <PostTextWrap>
            {postText.split("\n").map((subtext) => {
              return <PostSubText> {subtext} </PostSubText>;
            })}
            {post.postText.isLongText && (
              <SeeMore>
                <SeeMoreBtn onClick={handleGoToPost}>
                  {translate("common:showMore")}
                </SeeMoreBtn>
              </SeeMore>
            )}
          </PostTextWrap>
        </div>
      )}
      <BottomButtonWrap>
        <ActionBtn onClick={handleGoToPost}>
          <GoCommentDiscussion size={15} />
          <span>
            {post.comments.length > 0
              ? translate("web:general.comments")
              : translate("web:general.comment")}
          </span>
        </ActionBtn>

        {post.postType === "Prayer Request" ? (
          <ActionBtn
            isUserPraying={isUserInLikes}
            onClick={handleLikePost}
            className="commentSectionIcon"
          >
            <FaPray color={color} size={16} />
            {isPostLikeLoading && likePostLoading === post._id ? (
              <SpinnerSmall border={"var(--themeColor)"} />
            ) : user._id === post.creator._id ? (
              <div>{translate("web:general.seeWhoIsPraying")}</div>
            ) : (
              <div className="commentSectionIconText" style={{ color: color }}>
                {isUserInLikes ? (
                  <>{translate("web:general.youArePraying")}</>
                ) : (
                  <>{translate("web:general.pray")}</>
                )}
              </div>
            )}
          </ActionBtn>
        ) : (
          <ActionBtn onClick={handleLikePost} style={{ color: color }}>
            <MdEmojiPeople
              color={color}
              style={{ fontSize: "14px" }}
              onClick={handleLikePost}
            />
            {isUserInLikes ? (
              <span>{translate("web:general.praisingTheLord")}</span>
            ) : (
              <span>{translate("web:general.praiseTheLord")}</span>
            )}
          </ActionBtn>
        )}
      </BottomButtonWrap>
      <DestructiveConfirmModal
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
        onConfirm={handleConfirmDelete}
        loading={isPostDeletedLoading}
        title={translate("feed:delete.title")}
        description="This post and its conversation will be permanently removed. This action cannot be undone."
      />
    </div>
  );
}

const BottomButtonWrap = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
`;

const ActionBtn = styled(pBtnSmall)`
  color: ${(props) => (props.isUserPraying ? "#009eb3" : "#707070")};
  background-color: white;

  &:hover {
    background-color: #ebebeb;
  }
`;

const StyledMTA = styled.div`
  font-size: x-small;
  display: none;

  @media (max-width: 768px) {
    display: flex;
  }
`;

const PostItemType = styled.div`
  padding: 4px 8px;
  color: ${(props) => (props.visible ? "white" : "transparent")};
  background-color: ${(props) => (props.visible ? "#46801fac" : "transparent")};
  border-radius: 4px;
  margin-left: 15px;
  font-size: x-small;
  transition: all 0.5s ease-in-out;
  @media (max-width: 768px) {
    margin-left: 10px;
    padding: 4px 4px;
  }
`;

export default PostItem;
